export const PAUSEQUEUE_TASK = 'pauseQueue_task';
export const PAUSEQUEUE_TASK_SUCCESSFUL = 'pauseQueue_task_successfull';
export const PAUSEQUEUE_TASK_FAILED = 'pauseQueue_task_failed';



